import { moreEventItems } from '@/data'; // Import local fallback data
import type { EventItem } from '@/types';
import { mapDtosToEventItems } from '@/utils/dtoTransformers/eventItemDTO';

export async function fetchMoreEvents(rev: number | undefined): Promise<{moreEvents: EventItem[], revision: number}> {
  let moreEvents: EventItem[] = [];
  let revision: number;
  // console.log("Fetching more events with rev:", rev);
  
  let params;
  let urlParams = '';
  if(rev !== undefined){
    params = new URLSearchParams({
      rev: rev.toString()
    });
    urlParams = '?' + params.toString();
  }

  try {
    const response = await fetch('/of2/json/more_events' + urlParams, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    // console.log("Fetched more events data:", data);

    moreEvents = Array.isArray(data.events) ? mapDtosToEventItems(data.events) : [];
    revision = data.rev;
  } 
  catch (e) {
    // console.error("Failed to fetch more events:", e);
    // Temporary fallback for frontend testing if backend is broken
    // TODO replace fallback data with empty lists []
    moreEvents = moreEventItems;
    revision = 0; // or some default value indicating no revision
  }

  return {moreEvents, revision};
}